import React from 'react'
import { Routes, Route } from 'react-router-dom'
import FirstLoadGate from './components/FirstLoadGate.jsx'
import Navbar from './components/Navbar.jsx'
import Footer from './components/Footer.jsx'
import AuthModal from './components/AuthModal.jsx'
import { AuthProvider } from './lib/auth.jsx'

import Home from './pages/Home.jsx'
import Media from './pages/Media.jsx'
import Roadmap from './pages/Roadmap.jsx'
import Launcher from './pages/Launcher.jsx'
import News from './pages/News.jsx'
import Account from './pages/Account.jsx'
import Terms from './pages/Terms.jsx'
import Privacy from './pages/Privacy.jsx'
import Admin from './pages/Admin.jsx'
import NotFound from './pages/NotFound.jsx'

export default function App() {
  const [authOpen, setAuthOpen] = React.useState(false)
  const [authMode, setAuthMode] = React.useState('login')

  function openAuth(mode) {
    setAuthMode(mode || 'login')
    setAuthOpen(true)
  }

  return (
    <AuthProvider>
      <FirstLoadGate>
        <div className="min-h-screen flex flex-col">
          <Navbar onOpenAuth={openAuth} />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/media" element={<Media />} />
              <Route path="/roadmap" element={<Roadmap />} />
              <Route path="/launcher" element={<Launcher />} />
              <Route path="/news" element={<News />} />
              <Route path="/account" element={<Account />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <AuthModal open={authOpen} mode={authMode} onClose={() => setAuthOpen(false)} />
        </div>
      </FirstLoadGate>
    </AuthProvider>
  )
}
